<template>
    <div>
        <div class="timeline timeline-5">
            <div class="timeline-items">
                <div class="timeline-item">
                    <div class="timeline-media bg-light-primary">
                        <i class="fas fa-check"></i>
                    </div>
                    <div class="timeline-desc timeline-desc-light-primary">
                        <span
                            class="d-block font-weight-bolder text-primary mb-2"
                            >Geschäftsauswahl</span
                        >
                        <div>
                            <div class="form-group mb-8">
                                <div
                                    class="alert alert-custom alert-default"
                                    role="alert"
                                >
                                    <div class="alert-icon">
                                        <i class="fas fa-info text-primary"></i>
                                    </div>
                                    <div class="alert-text">
                                        Für welches Geschäft wollen Sie die
                                        Einstellungen vornehmen.<br />
                                        Wählen Sie "Für Alle verwenden" aus,
                                        falls Sie ein Mapping für alle Geschäfte
                                        verwenden wollen.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group mb-4">
                                <label for="company_select"
                                    >Geschäft wählen</label
                                >
                                <select
                                    class="form-control form-control-sm"
                                    id="company_select"
                                    v-model="selectedStore"
                                    @change="setCurrentSettings"
                                >
                                    <option v-show="forAllStores" value="0"
                                        >Für alle Geschäfte</option
                                    >
                                    <option v-show="!forAllStores" value="0"
                                        >bitte wählen...</option
                                    >
                                    <option
                                        v-for="store in stores"
                                        :key="store.id"
                                        :value="store.id"
                                    >
                                        {{ store.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group mb-4 row">
                                <label
                                    class="col-6 col-form-label"
                                    >Für alle Geschäfte übernehmen</label
                                >
                                <div class="col-6">
                                    <span
                                        class="switch switch-outline switch-icon switch-success"
                                    >
                                        <label>
                                            <input
                                                type="checkbox"
                                                name="for_all_stores"
                                                v-model="forAllStores"
                                            />
                                            <span></span>
                                        </label>
                                    </span>
                                </div>
                                <div class="col-12">
                                    <p class="form-text text-muted">
                                        Achtung, die unten stehenden
                                        Einstellungen werden beim Speichern für
                                        alle Geschäfte übernommen!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="timeline-item mt-4">
                    <div class="timeline-media bg-light-primary">
                        <i class="fas fa-upload"></i>
                    </div>
                    <div class="timeline-desc timeline-desc-light-primary">
                        <span
                            class="d-block font-weight-bolder text-primary mb-2"
                            >FTP-Einstellungen</span
                        >
                        <div>
                            <div class="form-group mb-8">
                                <div
                                    class="alert alert-custom alert-default"
                                    role="alert"
                                >
                                    <div class="alert-icon">
                                        <i class="fas fa-info text-primary"></i>
                                    </div>
                                    <div class="alert-text">
                                        Manueller Upload oder hinterlegen Sie
                                        die FTP Zugangsdaten damit die
                                        Lagerlisten automatisiert abgeholt,
                                        eingelesen und aktualisiert werden
                                        können.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-4 col-form-label"
                                    >Manuell hochladen.
                                </label>
                                <div class="col-4">
                                    <span
                                        class="switch switch-outline switch-icon switch-success"
                                    >
                                        <label>
                                            <input
                                                type="checkbox"
                                                v-model="useFtp"
                                                name="use_ftp"
                                            />
                                            <span></span>
                                        </label>
                                    </span>
                                </div>
                                <label class="col-4 col-form-label"
                                    >Eigener FTP Ablageort</label
                                >
                            </div>
                            <div v-if="useFtp">
                                <div class="form-group row">
                                    <label
                                        class="col-2 col-form-label"
                                        >Host-URL</label
                                    >
                                    <div class="col-10">
                                        <input
                                            class="form-control"
                                            type="text"
                                            placeholder="ftp.storeplus.de"
                                            v-model="form.host"
                                        />
                                        <span class="form-text text-muted"
                                            >Die Adresse des FTP-Servers.</span
                                        >
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        class="col-2 col-form-label"
                                        >Benutzer</label
                                    >
                                    <div class="col-10">
                                        <input
                                            class="form-control"
                                            type="text"
                                            placeholder="User"
                                            v-model="form.user"
                                        />
                                        <span class="form-text text-muted"
                                            >Der FTP-User.</span
                                        >
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        class="col-2 col-form-label"
                                        >Password</label
                                    >
                                    <div class="col-10">
                                        <input
                                            class="form-control"
                                            type="text"
                                            placeholder="Passwort"
                                            v-model="form.password"
                                        />
                                        <span class="form-text text-muted"
                                            >Das Passwort des Users.</span
                                        >
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label
                                        class="col-2 col-form-label"
                                        >Verzeichnis</label
                                    >
                                    <div class="col-10">
                                        <input
                                            class="form-control"
                                            type="text"
                                            placeholder="Verzeichnis"
                                            v-model="form.ftp_dir"
                                        />
                                        <span class="form-text text-muted"
                                            >Der Name des Ordners in /ftp</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="timeline-item mt-4">
                    <div class="timeline-media bg-light-primary">
                        <i class="fas fa-sitemap"></i>
                    </div>
                    <div class="timeline-desc timeline-desc-light-primary">
                        <span
                            class="d-block font-weight-bolder text-primary mb-2"
                            >Optionen</span
                        >
                        <div>
                            <div class="form-group mb-8">
                                <div
                                    class="alert alert-custom alert-default"
                                    role="alert"
                                >
                                    <div class="alert-icon">
                                        <i class="fas fa-info text-primary"></i>
                                    </div>
                                    <div class="alert-text">
                                        Die bereits vorhandenen Werte sind
                                        meistens Standard. Bitte überprüfen Sie
                                        die Felder und passen Sie diese bei Bedarf
                                        an.
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 mb-4">
                                    <label>Delimiter</label>
                                    <input
                                        class="form-control"
                                        type="text"
                                        placeholder="Delimiter"
                                        maxlength="1"
                                        v-model="form.delimiter"
                                    />
                                    <span class="form-text text-muted"
                                        >Das Trennzeichen der CSV. Für Tab "t"
                                        eingeben.</span
                                    >
                                </div>
                                <div class="col-6 mb-4">
                                    <label>Enclosure</label>
                                    <input
                                        class="form-control"
                                        type="text"
                                        placeholder="Enclosure"
                                        maxlength="1"
                                        v-model="form.enclosure"
                                    />
                                    <span class="form-text text-muted"
                                        >Falls Texte umschlossen werden, wird
                                        das Zeichen hier angegeben.</span
                                    >
                                </div>
                                <div class="col-6 mb-4">
                                    <label>Header Offset</label>
                                    <input
                                        class="form-control"
                                        type="number"
                                        placeholder="Header Offset"
                                        v-model="form.header_offset"
                                    />
                                    <span class="form-text text-muted"
                                        >Der Abstand zur Zeile mit den
                                        Überschriften.</span
                                    >
                                </div>
                                <div class="col-6 mb-4">
                                    <label>Spaltennamen</label>
                                    <span
                                        class="switch switch-outline switch-icon switch-success"
                                    >
                                        <label class="mr-2">
                                            <input
                                                type="checkbox"
                                                v-model="form.no_column_names"
                                            />
                                            <span></span>
                                        </label>
                                        Keine Spaltennamen
                                    </span>

                                    <span class="form-text text-muted"
                                        >Gibt an ob die Spalten der CSV benannt sind.</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="timeline-item mt-4">
                    <div class="timeline-media bg-light-primary">
                        <i class="fas fa-map-signs"></i>
                    </div>
                    <div class="timeline-desc timeline-desc-light-primary">
                        <span
                            class="d-block font-weight-bolder text-primary mb-2"
                            >Felder Mappen</span
                        >
                        <div>
                            <div class="form-group mb-8">
                                <div
                                    class="alert alert-custom alert-default"
                                    role="alert"
                                >
                                    <div class="alert-icon">
                                        <i class="fas fa-info text-primary"></i>
                                    </div>
                                    <div class="alert-text">
                                        "mappen" Sie die Spaltennamen aus Ihrer
                                        Datei in die dazu vorhergesehenen Felder
                                        auf der rechten Seite.
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <h4 class="mb-4">
                                        Spaltennamen auslesen
                                        <small
                                            >klicken Sie oder ziehen Sie
                                            ihre Datei auf das
                                            Feld</small
                                        >
                                    </h4>
                                    <vue-dropzone
                                        ref="fileDropzone"
                                        id="file_dropzone"
                                        :options="dropzoneOptions"
                                        @vdropzone-complete="afterComplete"
                                    >
                                    </vue-dropzone>
                                </div>
                                <div class="col-12">
                                    <h3 class="my-4">
                                        Mapping erstellen
                                        <small
                                            >bitte passende Spalten
                                            zuordnen</small
                                        >
                                    </h3>
                                </div>
                                <div class="col-6">
                                    <h4 class="mb-4">
                                        Spalten aus Datei
                                        <small
                                            >oder manuell
                                            eintragen</small
                                        >
                                    </h4>
                                    <draggable
                                        class="list-group"
                                        :list="sourceFields"
                                        group="target"
                                    >
                                        <div
                                            class="list-group-item"
                                            v-for="(element,
                                            index) in sourceFields"
                                            :key="element.name"
                                        >
                                            {{ element.name }}
                                        </div>
                                    </draggable>
                                </div>
                                <div class="col-6">
                                    <h3>Zielstruktur</h3>
                                    <draggable
                                        class="list-group"
                                        :list="targetFields"
                                        group="target"
                                        @add="replace"
                                    >
                                        <div
                                            class="list-group-item"
                                            v-for="(element,
                                            index) in targetFields"
                                            :key="index"
                                        >
                                            <div class="input-group">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="
                                                        element.source
                                                    "
                                                />
                                                <div
                                                    class="input-group-append"
                                                >
                                                    <span
                                                        class="input-group-text"
                                                        >{{
                                                            element.name
                                                        }}</span
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </draggable>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <button
                                            type="button"
                                            @click="submitSettings"
                                            class="btn btn-success"
                                        >
                                            Einstellungen speichern
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Draggable from "vuedraggable";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
    name: "StockSettings",

    components: {
        vueDropzone: vue2Dropzone,
        Draggable
    },
    props: {
        connectors: {
            type: Array,
            default: () => []
        },
        stores: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            dropzoneOptions: {
                url: route("stock-upload.store", {
                    _token: this.$csrf_token(),
                    only_column_check: true
                }),
                thumbnailWidth: 150,
                uploadMultiple: false,
                parallelUploads: 1,
                autoProcessQueue: true,
                addRemoveLinks: true,
                dictDefaultMessage:
                    "<i class='fa fa-upload'></i> Datei hier uploaden"
            },
            form: {
                delimiter: ";",
                enclosure: "",
                header_offset: 0,
                no_column_names: false,
                store_identifier: "",
                source: "manually",
                host: "",
                user: "",
                password: "",
                ftp_dir: "ftp.storeplus.de",
                url: "",
                header_map: {
                    gtin: "ean",
                    price: "price",
                    quantity: "quantity",
                    store_identifier: "store_id"
                }
            },
            sourceFields: [],
            targetFields: [
                { name: "EAN (GTIN)", source: "", id: 0 },
                { name: "Menge", source: "", id: 1 },
                { name: "Preis (VK)", source: "", id: 2 },
                { name: "Geschäft ID", source: "", id: 3 }
            ],

            selectedStore: null,
            forAllStores: false,
            useFtp: false
        };
    },

    methods: {
        async submitSettings() {
            if (
                this.useFtp &&
                (this.isEmpty(this.form.host) === true ||
                    this.isEmpty(this.form.user) === true ||
                    this.isEmpty(this.form.password) === true)
            ) {
                toastr.error("Alle FTP-Felder müssen befüllt sein!");
                return;
            }

            this.form.header_map.gtin = this.targetFields[0].source;
            this.form.header_map.quantity = this.targetFields[1].source;
            this.form.header_map.price = this.targetFields[2].source;
            this.form.header_map.store_identifier = this.targetFields[3].source;
            this.form.source = this.useFtp ? "ftp" : "manually";
            await axios
                .post(route("stock-upload.settings"), {
                    _token: this.$csrf_token(),
                    store: this.selectedStore,
                    store_identifier: this.store_identifier,
                    for_all_stores: this.forAllStores,
                    settings: this.form
                })
                .then(response => {
                    toastr.success("Einstellungen wurden gespeichert");
                    window.location = route('stock-upload.index')
                })
                .catch(error => {
                    toastr.error("Fehler");
                });
        },
        setCurrentSettings() {
            for (var key in this.connectors) {
                var connector = this.connectors[key];
                if (connector.store_uuid === this.selectedStore) {
                    this.form.delimiter = connector.delimiter;
                    this.form.enclosure = connector.enclosure;
                    this.form.header_offset = connector.header_offset;
                    this.form.no_column_names = connector.no_column_names;
                    this.form.source = connector.source;
                    this.form.store_identifier = connector.store_identifier;
                    this.form.host = connector.host;
                    this.form.user = connector.user;
                    this.form.password = connector.password;
                    this.form.ftp_dir = connector.ftp_dir;
                    this.form.url = connector.url;
                    this.targetFields[0].source = this.form.header_map.gtin =
                        connector.header_map.gtin;
                    this.targetFields[1].source = this.form.header_map.price =
                        connector.header_map.price;
                    this.targetFields[2].source = this.form.header_map.quantity =
                        connector.header_map.quantity;
                    this.targetFields[3].source = this.form.header_map.store_identifier =
                        connector.header_map.store_identifier;
                    this.useFtp = this.form.source === "ftp";
                }
            }
        },

        async afterComplete(response) {
            if (response.status === "success") {
                var columnList = JSON.parse(response.xhr.responseText);

                this.sourceFields = columnList.map(function(element, index) {
                    return { name: element, id: index, source: "" };
                });
            } else {
                toastr.error("Fehler beim Upload der Datei");
                this.$refs.fileDropzone.removeAllFiles();
            }
        },

        replace(el) {
            console.log(el);
            var index = el.newIndex - 1 < 0 ? el.newIndex : el.newIndex - 1;
            this.targetFields[index].source = el.item.innerText.trim();
            this.removeAt(index + 1);
        },
        removeAt(idx) {
            this.targetFields.splice(idx, 1);
        },
        isEmpty(value) {
            if (value === null || value === "" || value === undefined) {
                return true;
            }
            return false;
        },

    },

    mounted() {
        if (this.stores.length === 1) {
            this.selectedStore = this.stores[0].id;
            this.setCurrentSettings();
        }
    },

    watch: {
        forAllStores: function() {
            this.selectedStore = this.forAllStores ? 0 : this.stores[0].id;
        }
    }
};
</script>

<style scoped lang="scss">
.list-group-item {
    &:hover {
        border: 1px dashed #9881F6;
        cursor: move;
    }
}
</style>
